import styled from 'styled-components';
import { customPalette } from '../../theme';
import DefaultGrid from '../grid/DefaultGrid';

export const DisplayOnActiveRowClassName = 'displayOnActiveRow';
export const AlwaysDisplayClassName = 'alwaysVisible';

export const StyledTable = styled(DefaultGrid)`
    .e-headercell {
        background-color: ${customPalette.themeLighter} !important;
        font-weight: bold;
        font-size: var(--header-font-size);
        border: none;
    }

    .e-columnheader {
        height: 36px !important;
    }

    .e-headertext {
        font-size: var(--header-font-size);
        color: ${customPalette.blueDark};
        font-weight: 600;
        text-align: center;
    }

    th.e-headercell[aria-sort='ascending'] .e-headertext,
    th.e-headercell[aria-sort='descending'] .e-headertext,
    th.e-headercell[aria-sort='ascending'] .e-sortfilterdiv,
    th.e-headercell[aria-sort='descending'] .e-sortfilterdiv {
        color: ${customPalette.themePrimary};
    }

    .e-icon-ascending::before,
    .e-icon-descending::before {
        color: ${customPalette.themePrimary};
    }

    .e-icon-ascending::before {
        content: '\\e776';
    }

    .e-icon-descending::before {
        content: '\\e729';
    }

    .e-checkbox-wrapper.e-css {
        padding: unset;
    }

    .e-checkbox-wrapper .e-frame.e-icons {
        border-radius: 6px;
        border-color: ${customPalette.themePrimary};
    }

    .e-checkbox-wrapper .e-frame.e-icons.e-check {
        background-color: ${customPalette.themePrimary};
    }

    .e-checkbox-wrapper .e-frame.e-icons.e-stop {
        color: ${customPalette.themePrimary};
    }

    .e-gridheader .e-headercell .e-headercelldiv.e-headerchkcelldiv {
        margin-bottom: -5px;
    }

    &.e-grid.e-control .e-row .e-rowcell {
        background-color: #ffffff;
        color: ${customPalette.blueDark};
        font-size: 14px;
        border: none;
        font-weight: 600;
        border-bottom: 1px solid ${customPalette.statusCoolLightGrey};
        height: 100%;
    }

    &.e-grid.e-control .e-row .${AlwaysDisplayClassName} {
        display: inline-block;
    }

    &.e-grid.e-control .e-row:hover .${DisplayOnActiveRowClassName}, &.e-grid.e-control .e-row .e-focused .${DisplayOnActiveRowClassName} {
        display: inline-block;
    }

    .highlighted-search {
        background-color: ${customPalette.yellowDark};
    }
`;
